import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("#nav2").addClass("active");
$(function () {
    $(window).scroll(function () {
        // 可是窗口滚动条发生滚动的时候 垂直方向滚动到多少距离的时候 让头部导航条设置上一个固定定位的样式
        if ($(window).scrollTop() >= ($("header").height())) {
            // alert($("#slideBox").height());
            $("header").addClass("head1");
        } else {
            $("header").removeClass("head1");
        }
    })
})
var swiper = new Swiper(".product-nav .mySwiper", {
    slidesPerView: 7,
    centeredSlides: false,
    slidesPerGroup: 7,
    breakpoints: {
        320: { //当屏幕宽度大于等于320
            slidesPerView: 2,
            slidesPerGroup: 2,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 4,
            slidesPerGroup: 4,
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerView: 7,
            slidesPerGroup: 7,
        }
    },
    navigation: {
      nextEl: ".product-nav .swiper-button-next",
      prevEl: ".product-nav .swiper-button-prev",
    },
});

$(".swiper-slide").click(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".product .content").eq(index).addClass("active").siblings().removeClass("active");
})